<template>
  <main-layout>
    <b-container class="onboarding-profile-page page">
      <div class="page__card">
        <div class="page__card__content">
          <onboarding-profile-form />
        </div>
      </div>
    </b-container>
  </main-layout>
</template>
<script>
/**
 * ==================================================================================
 * Onboarding Profile page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'
import OnboardingProfileForm from '@/components/forms/OnboardingProfileForm'

export default {
  metaInfo: function() {
    return {
      title: 'Complete your details'
    }
  },
  components: {
    MainLayout,
    OnboardingProfileForm
  }
}
</script>
<style scoped lang="scss">
.onboarding-profile-page /deep/ {
  .page-subtitle:first-child {
    padding-top: 50px;
  }
}
</style>
